import { fetchUserPrivileges } from 'store/Users/actions'
import AxiosInstance from 'utils/AxiosInstance'
import * as types from './constants'

export const fetchCourseSettings = () => {
  return (dispatch) => {
    AxiosInstance.get('/settings/module_data').then((data) => {
      dispatch({ type: types.SET_COURSE_SETTINGS, data })
    })
  }
}

export const saveCourseSettings = () => {
  return (dispatch, getState) => {
    const {
      enableWelcomeEmail,
      disableEmailNewCourse,
      enableModuleLibrary,
      enableModuleMyReport,
      enableModuleDiscussion,
      enableCourseRedirectUrl,
      enableModuleLearningPlan,
      enableModuleCompliance,
      enableModuleDevelopment,
      enableModuleForms,
      enableRecruitment,
      enableModulePublicCatalog,
      userAdminMarkQuizPassed,
      enableModuleManagerReport,
      notStarted,
      inProgress,
      quizFailed,
      validation,
      completed,
      expired,
      reassigned,
      pastDue,
      userAdminMarkCourseComplete,
      userCourseManagerCanAddUser,
      userCourseManagerCanEditUser,
      enableCourseQuizRetakeDefault,
      userAreaAdminCanCreateCourses,
      userAreaAdminCanCreateCourseGroups,
      enableCourseGeneratingCertificate,
      enableCourseShowPastDueTrainings,
      userCourseManagerCanCreateCourse,
      enableGroupsManagerReport,
      enableCoursesManagerReport,
      includeDefaultCourses,
      enableCertificateBlinking,
      requireAgreementBeforeCertification,
      subject,
      emailBody,
      agreementContent,
      enableEmailCertificate,
      enableCategories,
      enableCourseGroupChecklist,
      enableUserExtraFields,
      enableUserAppearanceWithSameAccessLevel,
      sortCoursesByOrder,
      enableStatusLabels,
      enableKnowledgeQuestions,
      enableChecklistPercentage,
      enableModuleAllCourses,
      // recently added
      enableReorderCourseGroup,
      enableExternalReports,
      enableRoleGroups,
      enableLibraryUpdateEmail,
    } = getState().courseConfig
    const saveData = {
      enable_welcome_email: enableWelcomeEmail,
      disable_email_new_course: disableEmailNewCourse,
      enable_module_library: enableModuleLibrary,
      enable_module_my_report: enableModuleMyReport,
      enable_module_discussion: enableModuleDiscussion,
      enable_course_redirect_url: enableCourseRedirectUrl,
      enable_module_learning_plan: enableModuleLearningPlan,
      enable_module_compliance: enableModuleCompliance,
      enable_module_development: enableModuleDevelopment,
      enable_module_forms: enableModuleForms,
      enable_module_recruitment: enableRecruitment,
      enable_module_public_catalog: enableModulePublicCatalog,
      user_admin_mark_quiz_passed: userAdminMarkQuizPassed,
      enable_module_manager_report: enableModuleManagerReport,
      module_course_status_color_0: notStarted,
      module_course_status_color_1: inProgress,
      module_course_status_color_2: quizFailed,
      module_course_status_color_3: validation,
      module_course_status_color_4: completed,
      module_course_status_color_expired: expired,
      module_course_status_color_reassign: reassigned,
      module_course_status_color_past_due: pastDue,
      user_admin_mark_course_complete: userAdminMarkCourseComplete,
      user_course_manager_can_add_user: userCourseManagerCanAddUser,
      user_course_manager_can_edit_user: userCourseManagerCanEditUser,
      enable_course_quiz_retake_default: enableCourseQuizRetakeDefault,
      user_area_admin_can_create_courses: userAreaAdminCanCreateCourses,
      user_area_admin_can_create_course_groups:
        userAreaAdminCanCreateCourseGroups,
      enable_course_generating_certificate: enableCourseGeneratingCertificate,
      enable_course_show_past_due_trainings: enableCourseShowPastDueTrainings,
      user_course_manager_can_create_course: userCourseManagerCanCreateCourse,
      enable_groups_manager_report: enableGroupsManagerReport,
      enable_courses_manager_report: enableCoursesManagerReport,
      include_default_courses: includeDefaultCourses,
      enable_certificate_blinking: enableCertificateBlinking,
      require_agreement_before_certification:
        requireAgreementBeforeCertification,
      subject,
      emailBody,
      agreementContent,
      enable_email_certificate: enableEmailCertificate,
      enable_categories: enableCategories,
      enable_course_group_checklist: enableCourseGroupChecklist,
      enable_user_extra_fields: enableUserExtraFields,
      enable_module_all_courses: enableModuleAllCourses,
      enable_user_appearance_with_same_access_level:
        enableUserAppearanceWithSameAccessLevel,
      sort_courses_by_order: sortCoursesByOrder,
      enable_status_labels: enableStatusLabels,
      enable_knowledge_questions: enableKnowledgeQuestions,
      enable_checklist_percentage: enableChecklistPercentage,
      // recently added
      enable_reorder_course_groups: enableReorderCourseGroup,
      enable_external_reports: enableExternalReports,
      enable_role_groups: enableRoleGroups,
      enable_library_update_email: enableLibraryUpdateEmail,
    }

    return AxiosInstance.post('/settings/module_data', {
      module_data: JSON.stringify(saveData),
    }).then(() => dispatch(fetchUserPrivileges()))
  }
}

export const toggleCourseSettings = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: types.SET_COURSE_SETTINGS_VALUE,
      name: value,
      value: getState().courseConfig[value] === 1 ? -1 : 1,
    })
  }
}

export const handleColorChange = (optionName, value) => {
  return (dispatch) => {
    dispatch({ type: types.SET_STATUS_COLOR, name: optionName, value })
  }
}

export const onChangeEmailSubject = (value) => ({
  type: types.SET_SUBJECT,
  payload: value,
})

export const onChangeEmailBody = (value) => async (dispatch) => {
  dispatch({ type: types.SET_EMAIL, payload: value })
}

export const onChangeAgreementContent = (value) => async (dispatch) => {
  dispatch({ type: types.SET_AGREEMENT_CONTENT, payload: value })
}
